import { useEffect, useState } from "react";

export default function useAiInsights(buildingId, pauseRandomiser)
{
    const [loading, setLoading] = useState(true);

    const [assets, setAssets] = useState([]);
    const [insights, setInsights] = useState([]);

    const [allAssets, setAllAssets] = useState([]);
    const [allInsights, setAllInsights] = useState([]);

    const insightSummary =
    {
        critical:
            insights.filter(i => i.severity === "CRITICAL").length,

        medium:
            insights.filter(i => i.severity === "MEDIUM").length,

        low:
            insights.filter(i => i.severity === "LOW").length,

        na:
            insights.filter(i => i.severity === "NA").length
    };

    function randomSubset(list, min, max)
    {
        if(list.length === 0)
        {
            return [];
        }

        const count =
            Math.floor(
                Math.random() * (max - min + 1)
            ) + min;

        return [...list]
            .sort(() => Math.random() - 0.5)
            .slice(0, count);
    }

    function randomise(assetList = allAssets, insightList = allInsights)
    {
        if(assetList.length === 0 || insightList.length === 0)
        {
            return;
        }

		setAssets(
		    randomSubset(assetList, 20, 35)
		);

		setInsights(
		    randomSubset(insightList, 10, 18)
		);
    }

    async function load()
    {
        setLoading(true);

        const assetsResponse =
            await fetch("/demo/assets.json");

        const insightsResponse =
            await fetch("/demo/insights.json");

        const loadedAssets =
            await assetsResponse.json();

        const loadedInsights =
            await insightsResponse.json();

        setAllAssets(loadedAssets);
        setAllInsights(loadedInsights);

        // Show something immediately
        randomise(
            loadedAssets,
            loadedInsights
        );

        setLoading(false);
    }

    const reload = () =>
    {
        load();
    };

    useEffect(() =>
    {
        load();

    }, [buildingId]);

	useEffect(() =>
	{
	    if(pauseRandomiser)
	    {
	        return;
	    }

	    const timer =
	        setInterval(
	            () => randomise(),
	            5000
	        );

	    return () =>
	        clearInterval(timer);

	},
	[
	    pauseRandomiser,
	    allAssets,
	    allInsights
	]);

    return {

        loading,

        assets,

        insights,

        insightSummary,

        reload

    };
}